import { ContractsList } from '@Resources/contracts/ContractsList';
import { ContractsShow } from '@Resources/contracts/ContractsShow';
import { ResourceDefinition } from '@Utils/types';

export const contractsResource: ResourceDefinition = {
  options: { label: 'menu.contracts' },
  list: ContractsList,
  show: ContractsShow,
};
